<template>
  <div id="order">
    <img src="@/assets/top.png" class="top" />
    <div class="nav">
      <div class="left" @click="toUrl('/record')">
        <van-icon name="arrow-left" size="20" />
      </div>

      <div class="center">
        预约详情
        <!-- <img src="@/assets/logo.png" width="21" />
        <span style="margin-left:0.3rem">青山湖区智慧残联</span>-->
      </div>
      <div class="right" @click="toHref()">
        <van-icon name="wap-home" size="21" />
      </div>
    </div>
    <div class="order-main padding">
      <van-loading v-show="loading" size="24px">加载中...</van-loading>
      <div class="order-top" v-show="!loading">
        <div class="changList-img">
          <img :src="intro.picture" />
        </div>
        <div class="order-info">
          <div class="info1">{{intro.name}}</div>
          <div class="info2">{{intro.description}}</div>
        </div>
      </div>
      <div class="order-center" v-show="!loading">
        <div class="order-tit">
          <van-icon name="clock-o" size="22" color="#9BE650" />
          <span>预约时间段</span>
        </div>
        <!-- 全天可约 -->
        <div class="order-time" v-if="info.scheduled_time==1">
          <div class="order-time1 timeActive border-radius">上午（9：00~11：00）</div>
        </div>
        <div class="order-time" v-if="info.scheduled_time==2">
          <div class="order-time1 timeActive border-radius">下午（14：00~16：00）</div>
        </div>
        <div class="order-tit">
          <van-icon name="orders-o" size="22" color="#9BE650" />
          <span>预约信息</span>
        </div>
        <div class="order-form">
          <van-field v-model="info.username" readonly label="姓名" />
          <van-field v-model="info.telphone" readonly type="tel" label="手机号" />
          <van-field v-model="info.people_number" readonly type="digit" label="总人数" />
          <van-field
            class="form-b"
            readonly
            v-model="info.disabled_number"
            type="digit"
            label="残疾人数："
            placeholder="请输入残疾人数"
          />
          <van-field v-model="info.scheduled_date" readonly label="预约时间" />
          <van-field v-model="info.create_time" readonly label="申请时间" />
        </div>
        <div class="commit" v-if="info.status == 1" @click="toComfirm()">取消预约</div>
        <div class="commit commit-cancel" v-if="info.status == 2">已取消</div>
        <div class="commit btn2" v-if="info.status == 3">已通过</div>
        <div class="commit btn3" v-if="info.status == 4">已拒绝</div>
      </div>
    </div>
    <van-dialog v-model="show" title="提示" show-cancel-button :beforeClose="beforeClose">
      <div style="margin:1.5rem 0">您确定要取消预约吗？</div>
    </van-dialog>
  </div>
</template>
<script>
import { Icon, Field, Loading, Toast, Dialog } from "vant";
import { reserveInfo, reserveCancel, venueInfo } from "@/api/apiData";
export default {
  components: {
    [Icon.name]: Icon,
    [Field.name]: Field,
    [Loading.name]: Loading,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      active: 1,
      name: "",
      phone: "",
      people: "",
      disability: "",
      id: "",
      date: "",
      info: [],
      loading: true,
      token: "",
      show: false,
      intro: [],
    };
  },
  mounted() {
    let id = this.$route.query.id;
    let date = this.$route.query.date;
    let token = localStorage.getItem("tokenY");
    if (token) {
      this.token = token;
    } else {
      this.$router.push("/venue");
    }
    this.id = id;
    this.date = date;
    this.getInfo();
  },
  methods: {
    toUrl(u) {
      this.$router.push(u);
    },
    // 跳转首页
    toHref() {
      window.location.href =
        "http://ncymkj.doudou00.com/index.php?g=Wap&m=Index&a=lists&token=hmatos1596436588&classid=20403";
    },
    getInfo() {
      var parm = {
        token: this.token,
        id: this.id,
      };
      reserveInfo(parm).then((res) => {
        if (res.status == 1) {
          this.info = res.data;
          this.getVenue(res.data.venue_id);
        } else {
        }
      });
    },
    getVenue(id) {
      venueInfo({ id: id }).then((res) => {
        if (res.status == 1) {
          this.intro = res.data;
          this.loading = false;
        } else {
          Toast(res.message);
        }
      });
    },
    toComfirm() {
      this.show = true;
    },
    beforeClose(action, done) {
      if (action === "confirm") {
        var parm = {
          token: this.token,
          id: this.id,
        };
        reserveCancel(parm).then((res) => {
          Toast(res.message);
          if (res.status == 1) {
            setTimeout(done);
            this.$router.push("/record");
          }
        });
      } else {
        done();
      }
    },
  },
};
</script>
<style scoped>
.order-top {
  position: relative;
}
.order-top img {
  width: 100%;
}
.changList-img {
  max-height: 16rem;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1rem;
}
.order-status {
  position: absolute;
  top: 0;
  right: 0;
  background: #9ce17a;
  color: white;
  padding: 0.3rem 0.5rem 0.3rem 1rem;
  border-radius: 1rem 0 0px 1rem;
  box-shadow: 0px 0px 3px 0px #64ac64;
}
.order-info {
  display: flex;
  position: absolute;
  bottom: 0;
  background: rgba(33, 33, 33, 0.68);
  width: 100%;
  color: white;
  height: 1.5rem;
  /* padding: 1rem; */
  /* overflow: hidden; */
  line-height: 1.5rem;
  font-size: 0.9rem;
}
.info1 {
  width: 30%;
  text-align: left;
  padding-left: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.info2 {
  width: 65%;
  text-align: right;
  padding-right: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-left: 5%;
}
.order-tit {
  display: flex;
  height: 1.4rem;
  line-height: 1.4rem;
}
.order-tit span {
  margin-left: 0.3rem;
}
.order-center {
  padding: 1rem;
}
.order-time {
  display: flex;
  border: solid 1px #44911e;
  color: #6fcb15;
  /* padding: 0 0.5rem; */
  margin-top: 1rem;
  border-radius: 0.5rem;
  height: 2rem;
  line-height: 2rem;
  font-size: 0.9rem;
  margin-bottom: 1.5rem;
}
.order-time div {
  flex: 1;
}
.order-time1 {
  border-right: solid 1px;
  border-radius: 0.5rem 0 0 0.5rem;
}
.order-time2 {
  border-radius: 0 0.5rem 0.5rem 0;
}
.timeActive {
  background: linear-gradient(to right, #9be650, #6dcc13);
  color: white;
}
.order-form {
  width: 93%;
  margin: 0 auto;
  padding-top: 0.5rem;
}
.form-b::before {
  position: absolute;
  box-sizing: border-box;
  content: " ";
  pointer-events: none;
  right: 16px;
  bottom: 0;
  left: 16px;
  border-bottom: 1px solid #ebedf0;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
}
.commit {
  width: 50%;
  margin: 0 auto;
  background: #9ce17a;
  color: white;
  line-height: 2.5rem;
  font-size: 1.2rem;
  font-weight: bold;
  border-radius: 1.5rem;
  margin-top: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0px 0px 3px 0px #64ac64;
}
.commit-cancel {
  background: gainsboro;
  color: grey;
}
.box-shadow {
  box-shadow: 0px 0px 3px 0px #ff9800 !important;
}
.box-shadow2 {
  box-shadow: 0px 0px 3px 0px red !important;
}
.border-radius {
  border-radius: 0.5rem;
  border: #44911e;
}
.btn2 {
  background: green !important;
  color: white !important;
}
.btn3 {
  background: red !important;
  color: white !important;
}
</style>


// WEBPACK FOOTER //
// src/page/recordInfo.vue